import { fonts } from 'app-v2/design-systems/typography/fonts'
import { ResponsiveContainer, media } from 'app/assets/styles'
import { H1, Text } from 'app/common/typography'
import { colors as oldColors } from 'shared/assets/styles'
import styled from 'styled-components'

const { red } = oldColors

export const StyledContainer = styled.div`
    position: relative;
    margin-top: 60px;
    ${media.medium`
        margin-top: 90px;
    `};
    & span,
    & div {
        font-family: ${fonts.flameSansRegular};
    }
`

export const StyledHeader = styled.div`
    position: absolute;
    top: 0;
    z-index: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: ${red};
    padding: 30px 0;
    ${media.medium`
        padding: 110px 0;
        min-height: 200px;
    `};
`

export const StyledDescription = styled(Text)`
    white-space: pre-line;
`

export const StyledBlock = styled(ResponsiveContainer)`
    padding-top: 30px;
    padding-bottom: 30px;
    text-align: center;
    background: white;
    width: 100%;
    margin: 30px 0;
    ${media.medium`
        border-radius: 12px;
        margin: 50px auto 140px;
        box-shadow: 0 8px 16px 4px rgba(48,49,51,.1);
        padding: 60px 105px;
        max-width: 850px;
    `};
`

export const StyledContent = styled.div`
    z-index: 10;
    position: relative;
`

export const StyledForm = styled.div`
    margin: 70px 20px 0;
    ${media.medium`
        margin: 70px 0 0 0;
    `}
`

export const StyledBurgerIconContainer = styled.div`
    margin-left: -30px;
    visibility: hidden;
    ${media.medium`
        visibility: visible;
    `};
`

export const StyledQuestionIconContainer = styled.div`
    margin-right: -30px;
    visibility: hidden;
    ${media.medium`
        visibility: visible;
    `};
`

export const StyledTitle = styled(H1)`
    padding-top: 30px;
`

export const StyledSuccess = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 30vh;
`

export const StyledText = styled(Text)`
    white-space: pre-line;
`
